import React from "react";
export class FALayerIcon extends React.Component<FALayerIconProps, any>{
    private ref: HTMLElement;

    private setRef = (r) => {
        if (r !== null) {
            this.ref = r;
            let that = this;
            if (this.props.renderSvgComplete) {
                var observer = new MutationObserver(function (mutations) {
                    mutations.forEach(function (mutation) {
                        for (let i = 0; i < mutation.addedNodes.length; i++) {
                            if (mutation.addedNodes[i].nodeName == "svg") {
                                observer.disconnect();
                                that.props.renderSvgComplete();
                            }
                        }
                    });
                });
                observer.observe(this.ref, { childList: true });
            }
        }
    }

    render() {
        //const attr = Array.isArray(this.props.attributes) ? (" " + this.props.attributes.map(a => "fa-" + a).join(" ") + " ") : "";

        const name = this.props.icons.map(i => i.name).join("__");

        return (
            <div ref={(r) => this.setRef(r)} key={name} style={this.props.style} className={this.props.wrapperClass} title={this.props.wrapperToolTip}>
                <span className="fa-stack fa-fw" style={{ position: "relative" }} >
                    {
                        this.props.icons.map((icon, idx) => {
                            if (icon.isText === true) {
                                return <span key={idx} className="fa-layers-text" data-fa-transform={icon.transforms} style={icon.style}>{icon.name}</span>
                            } else {
                                const attr = Array.isArray(icon.attributes) ? (" " + icon.attributes.map(attr => "fa-" + attr).join(" ") + " ") : "";
                                return <i key={idx} className={`fal fa-${icon.name} ` + attr} data-fa-transform={icon.transforms} aria-hidden="true" style={icon.style}></i>
                            }
                        })
                    }
                </span>
            </div>
        )
    }
}

interface FALayerIconProps {
    icons: Array<FALayerIconPart>;
    sameWidth?: boolean;
    style?: React.CSSProperties;
    wrapperClass?: string;
    wrapperToolTip?: string;
    renderSvgComplete?();
}

export interface FALayerIconPart {
    name: string;
    attributes?: Array<string>;
    isText?: boolean;
    transforms?: string;
    style?: React.CSSProperties;
}